import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import styles from "../../../styles/AccountModals.module.css";
import { BASE_URL } from "../../../utils/constants";

import { handleApiError } from "../../../utils/handleApiError";

import Button from "../../../components/button-v1";

import AlertDialog from "../../../components/alert-dialogue";
import { useQueryClient } from "@tanstack/react-query";
const DeleteStaff = ({
  isOpen,
  onClose,
  staff_info,
  comp_renderer,
  current_render,
}) => {
  const queryClient = useQueryClient();
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  const inactiveStaff = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/external_providers/${staff_info.id}/`;

    try {
      setLoading(true);
      const response = await axios.delete(
        url,
        // { active: false },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      queryClient.invalidateQueries(["external-providers"]);
      toast.success("Staff Deleted successfully.");
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    inactiveStaff();
  };

  if (!isOpen) return null;

  return (
    <AlertDialog
      open={isOpen}
      setOpen={onClose}
      title="Delete External Provider"
      description={`Are you sure you want to remove ${staff_info?.name}`}
    >
      <Button variant="ghost" onClick={onClose}>
        Cancel
      </Button>
      <Button
        loading={loading}
        variant="danger"
        size="default"
        onClick={handleSubmit}
      >
        Delete
      </Button>
    </AlertDialog>
  );
};

export default DeleteStaff;
